<template>
  <div>
    <h1>Create/Edit Parent Category</h1>
    <section>
      <b-field label="Name">
        <b-input type="text" v-model="parentCategory.name" placeholder="Name" required></b-input>
      </b-field>
      <div class="controls">
        <button class="button is-primary" @click="saveCategory">Save</button>
        <button
          v-if="parentCategoryId"
          class="button is-danger"
          @click="deleteCategory"
        >{{ deleteCategoryText }}</button>
      </div>
    </section>
  </div>
</template>

<script>
import { firestore } from "@/firebase";
const PARENT_CATEGORIES_COLLECTION = "ParentCategories";
import { ToastProgrammatic as Toast } from 'buefy'

export default {
  props: ["parentCategoryId"],
  data() {
    return {
      deletingCategory: false,
      parentCategory: {
        name: null,
      }
    };
  },
  mounted() {
    if (this.parentCategoryId != null) {
      let ref = `/${PARENT_CATEGORIES_COLLECTION}/${this.parentCategoryId}`;
      firestore
        .doc(ref)
        .get()
        .then(doc => {
          if (doc.exists) {
            let categoryData = doc.data();
            this.parentCategory.name = categoryData.name;
          } else {
            Toast.open({
              message: "No such document available",
              type: "is-danger",
              duration: 3000,
              position: "is-bottom"
            });
            this.$router.go(-1);
          }
        })
        .catch(error => {
          console.log("error getting document : " + error);
        });
    }
  },
  methods: {
    saveCategory: function() {
      var dataToSave = {
        name: this.parentCategory.name,
      };
      var saveSuccessFullHanlder = () => {
        Toast.open({
          message: "The parent category has been recorded",
          type: "is-success",
          duration: 3000,
          position: "is-bottom"
        });
        this.$router.go(-1);
      };
      if (this.parentCategoryId) {
        let ref = `/${PARENT_CATEGORIES_COLLECTION}`;
        firestore
          .collection(ref)
          .doc(this.parentCategoryId)
          .update(dataToSave)
          .then(saveSuccessFullHanlder);
      } else {
        let ref = `/${PARENT_CATEGORIES_COLLECTION}`;
        console.log(ref);
        firestore
          .collection(ref)
          .add(dataToSave)
          .then(saveSuccessFullHanlder)
          .catch(error => {
            console.log("Error adding parent category : " + error);
          });
      }
    },
    deleteCategory: function() {
      if (this.deletingCategory) {
        let ref = `/${PARENT_CATEGORIES_COLLECTION}/`;
        firestore
          .collection(ref)
          .doc(this.parentCategoryId)
          .delete()
          .then(() => {
            console.log("Parent Category deleted");
            Toast.open({
              message: "The Parent Category has been deleted",
              type: "is-success",
              duration: 3000,
              position: "is-bottom"
            });
            this.$router.go(-1);
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.deletingCategory = true;
      }
    }
  },
  computed: {
    deleteCategoryText: function() {
      if (this.deletingCategory) {
        return "Confirm Delete";
      } else {
        return "Delete";
      }
    }
  }
};
</script>